import React from 'react';
import BaseReport from './BaseReport';

type Props = {
  data: any;
  studentNameMap?: { [studentId: string]: string };
};

const LessonReport = ({ data, studentNameMap }: Props) => {
  return (
    <BaseReport
      data={data}
      studentNameMap={studentNameMap}
      reportType="lesson"
      showNoData={true}
      alwaysShowThreshold={false}
    />
  );
};

export default LessonReport;
